export default {
  CLAIM_ID: 'id',
  ROLE_BASIC: 'Basic',
  ROLE_OPERATOR: 'Operator',
  ROLE_ORGADMIN: 'OrgAdmin',
  CLAIM_AGORA_ADMIN_NAME: 'agora-admin',
  CLAIM_EMAIL: 'email',
  CLAIM_MEMBERSHIPS: 'memberships',
};
